import axiosInstance from "../utils/axios";

const API_ENDPOINTS = {
  CREATE_CONTACT: "api/Leads/CreateContact",
  GET_CONTACTS: "api/Leads/GetContacts",
  ASSIGN_CONTACT: "api/Leads/AssignContactToLead",
  UPDATE_CONTACT: "api/Leads/UpdateContact",
  DELETE_CONTACT: "api/Leads/DeleteContact",
  GET_ALL_CONTACTS: "api/Leads/getAllContacts",
};

export const createContact = async (contactData) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.CREATE_CONTACT, contactData);
    const responseData = response.data;
    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data,
        message: responseData.message || "Contact created successfully",
      };
    }
    return {
      success: false,
      error: responseData.message || "Failed to create contact",
      data: responseData.data
    };
  } catch (error) {
    console.error("Error creating contact:", error);
    const errorMessage = error.response?.data?.message || error.message || "Failed to create contact";
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to create contact",
      data: error.response?.data?.data
    };
  }
};

export const getContacts = async (leadId, search = "") => {
  try {
    const params = new URLSearchParams();
    if (leadId) params.append("LeadId", leadId);
    let processedSearch = search;
    if (search && /^[+\d\s()-]+$/.test(search) && /\d/.test(search)) {
      processedSearch = search.replace(/\s+/g, "");
    }
    if (processedSearch) params.append("Search", processedSearch);

    const url = `${API_ENDPOINTS.GET_CONTACTS}?${params.toString()}`;
    const response = await axiosInstance.get(url);
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let contacts = [];
      if (typeof responseData.data === "string") {
        try {
          contacts = JSON.parse(responseData.data);
        } catch (e) {
          console.error("Error parsing contacts:", e);
        }
      } else if (Array.isArray(responseData.data)) {
        contacts = responseData.data;
      }
      return { success: true, data: contacts, message: responseData.message };
    }
    return { success: false, error: responseData.message || "Failed to fetch contacts", data: [] };
  } catch (error) {
    console.error("Error fetching contacts:", error);
    return { success: false, error: error.response?.data?.message || error.message || "Failed to fetch contacts", data: [] };
  }
};

export const assignContactToLead = async (leadId, contactIds, jobId = null) => {
  try {
    const payload = {
      contacts: contactIds,
    };
    if (jobId) {
      payload.jobId = jobId;
    } else if (leadId) {
      payload.leadId = leadId;
    }

    const response = await axiosInstance.post(API_ENDPOINTS.ASSIGN_CONTACT, payload);
    const responseData = response.data;
    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data,
        message: responseData.message || "Contacts assigned successfully",
      };
    }
    return {
      success: false,
      error: responseData.message || "Failed to assign contacts"
    };
  } catch (error) {
    console.error("Error assigning contacts:", error);
    const errorMessage = error.response?.data?.message || error.message || "Failed to assign contacts";
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to assign contacts",
    };
  }
};

export const updateContact = async (contactData) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.UPDATE_CONTACT, contactData);
    const responseData = response.data;
    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data,
        message: responseData.message || "Contact updated successfully",
      };
    }
    throw new Error(responseData.message || "Failed to update contact");
  } catch (error) {
    console.error("Error updating contact:", error);
    const errorMessage = error.response?.data?.message || error.message || "Failed to update contact";
    return {
      success: false,
      error: errorMessage,
    };
  }
};

export const deleteContact = async (contactId) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.DELETE_CONTACT}/${contactId}`);
    const responseData = response.data;
    if (responseData.statusCode === 200 && responseData.status === "Success") {
      return {
        success: true,
        data: responseData.data,
        message: responseData.message || "Contact deleted successfully",
      };
    }
    throw new Error(responseData.message || "Failed to delete contact");
  } catch (error) {
    console.error("Error deleting contact:", error);
    const errorMessage = error.response?.data?.message || error.message || "Failed to delete contact";
    return {
      success: false,
      error: errorMessage,
    };
  }
};

export const getAllContacts = async (pageNumber = 1, pageSize = 10, search = "", sortColumn = "", sortDirection = "") => {
  try {
    const params = new URLSearchParams();
    params.append("PageNumber", pageNumber);
    params.append("PageSize", pageSize);
    let processedSearch = search;
    if (search && /^[+\d\s()-]+$/.test(search) && /\d/.test(search)) {
      processedSearch = search.replace(/\s+/g, "");
    }
    if (processedSearch) params.append("Search", processedSearch);
    if (sortColumn) params.append("SortColumn", sortColumn);
    if (sortDirection) params.append("SortDirection", sortDirection);

    const url = `${API_ENDPOINTS.GET_ALL_CONTACTS}?${params.toString()}`;
    const response = await axiosInstance.get(url);
    const responseData = response.data;

    if (responseData.statusCode === 200 && responseData.status === "Success") {
      let contacts = [];
      if (typeof responseData.data === "string") {
        try {
          contacts = JSON.parse(responseData.data);
        } catch (e) {
          console.error("Error parsing contacts:", e);
        }
      } else if (Array.isArray(responseData.data)) {
        contacts = responseData.data;
      }
      return { 
        success: true, 
        data: contacts, 
        totalRecords: responseData.totalRecords || contacts.length, 
        message: responseData.message 
      };
    }
    return { success: false, error: responseData.message || "Failed to fetch contacts", data: [], totalRecords: 0 };
  } catch (error) {
    console.error("Error fetching contacts:", error);
    return { success: false, error: error.response?.data?.message || error.message || "Failed to fetch contacts", data: [], totalRecords: 0 };
  }
};
